import React from 'react';
import Skeleton from 'react-loading-skeleton';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import styles from './CollectionLoading.module.scss';

const CollectionLoading = ({ showActionButtons = false }) => (
  <div className={styles.wrapper}>
    {/* Content area - grey background to match .bodyContainer */}
    <div className={styles.bodyContainer}>
      <Container>
        {/* Sidebar + content area */}
        <Row>
          <Col md="3">
            <Card className={styles.sidebarCard}>
              <Skeleton width={100} height={20} className="mb-3" />
              <Skeleton height={40} className="mb-1" />
              <Skeleton height={40} className="mb-1" />
              <Skeleton height={40} className="mb-1" />
            </Card>
          </Col>
          <Col md="9">
            {/* Search bar and optional action buttons */}
            <Row className={styles.searchRow}>
              <Col md={showActionButtons ? '7' : '6'}>
                <Skeleton height={40} />
              </Col>
              {showActionButtons && (
                <Col md="5">
                  <Row>
                    <Col xs="6">
                      <Skeleton height={40} />
                    </Col>
                    <Col xs="6">
                      <Skeleton height={40} />
                    </Col>
                  </Row>
                </Col>
              )}
            </Row>
            <Skeleton width={200} height={28} className="mb-1" />
            <Skeleton width={100} height={18} className="mb-4" />
            <Skeleton height={80} className="mb-2" />
            <Skeleton height={80} className="mb-2" />
            <Skeleton height={80} className="mb-2" />
          </Col>
        </Row>
      </Container>
    </div>
  </div>
);

export default CollectionLoading;
